import { ReactElement, useMemo } from 'react';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import { useQuerySitesByName } from '../../../../query/sites';
import { CommonInput } from '../../../common/Forms/Input';
import { SiteByNameModel } from '../../../../types/sites';
import { useDebouncedSearch } from '../../../../hooks/useDebouncedSearch';
import { SiteSelectList } from './SiteSelectList';

interface Props {
  onSiteSelect: (site: SiteByNameModel) => void;
  /**
   * Text for the select button.
   * Defaults to 'select' translation key.
   */
  selectButtonText?: string;
  selectButtonType?: 'button' | 'submit';
}

export const SITE_SELECT_SEARCH_MIN_LENGTH = 3;

export const SiteSelect = ({
                             onSiteSelect,
                             selectButtonText,
                           }: Props): ReactElement => {
  const { t } = useCommonTranslation();

  const { searchValue, setSearchValue, debouncedSearchValue } =
    useDebouncedSearch();

  const { data: sitesByName } = useQuerySitesByName(
    debouncedSearchValue,
    SITE_SELECT_SEARCH_MIN_LENGTH,
  );

  const suggestions = useMemo(() => sitesByName?.data.map((siteInfo, _) => ({
    id: siteInfo.id,
    name: siteInfo.name,
    info: siteInfo.sign_up_short_info,
  })), [sitesByName]);

  return (
    <>
      <CommonInput
        label={t('hospital')}
        labelPosition={'labelBefore'}
        required
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        value={searchValue}
        name={'hospital_search'}
        containerStyle={{ marginBottom: 0 }}
        onKeyPress={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        autoFocus
      />
      {suggestions && (
        <SiteSelectList
          onSiteSelect={onSiteSelect}
          suggestions={suggestions}
          selectButtonText={selectButtonText}
        />
      )}
    </>
  );
};
